import { useContext } from 'react'
import { Avatar } from '@/components/base/avatar'
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownLabel,
  DropdownMenu
} from '@/components/base/dropdown'
import { SidebarItem, SidebarLabel } from '@/components/base/sidebar'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import { CurrentTenantContext } from '@/core/current_tenant_context'

export const CompaniesDropdown = () => {
  const { currentCompany, setCurrentCompany, availableCompanies } = useContext(CurrentTenantContext)

  if (!currentCompany || availableCompanies.length == 0) return <></>

  const colors = [
    'bg-gray-500',
    'bg-red-500',
    'bg-yellow-500',
    'bg-green-500',
    'bg-blue-500',
    'bg-indigo-500',
    'bg-purple-500',
    'bg-pink-500'
  ]

  const avatarColorIndex = (initials: string) => {
    return [...initials].map(initial => initial.charCodeAt(0)).reduce((sum, next) => sum + next) % colors.length
  }

  const avatar = (company: typeof currentCompany) => {
    // if (company.darkLogo) {
    //   return <Avatar slot="icon" src={ company.darkLogo.url } className="bg-white" />
    // } else {
    const initials = company.name.substring(0, 2)
    return <Avatar className={`${colors[avatarColorIndex(initials)]} text-white`} initials={initials} slot="icon" />
    // }
  }

  return (
    <Dropdown>
      <DropdownButton as={SidebarItem} className="lg:mb-2.5">
        { avatar(currentCompany) }
        <SidebarLabel>{currentCompany.name}</SidebarLabel>
        <ChevronDownIcon />
      </DropdownButton>
      <DropdownMenu anchor="bottom start" className="min-w-80 lg:min-w-64">
        { availableCompanies.map(company => (
          <DropdownItem key={company.id} onClick={() => setCurrentCompany(company)}>
            { avatar(company) }
            <DropdownLabel>{ company.name }</DropdownLabel>
          </DropdownItem>
        ))}
        {/* <DropdownDivider />
        <DropdownItem href="/companies/new">
          <PlusIcon />
          <DropdownLabel>New company</DropdownLabel>
        </DropdownItem> */}
      </DropdownMenu>
    </Dropdown>
  )
}
